import { createRecipe } from './runtime';

const headingConfig = {"name":"heading","defaultVariants":{"size":"xl"},"variantMap":{"size":["4xl","3xl","2xl","xl","lg","md","sm","xs"],"variant":["marketing","label","subtitle"]}}

export const heading = /* @__PURE__ */ createRecipe(headingConfig)